type Params = { username: string; startChars?: number; endChars?: number };

const DEFAULT_START_CHARS = 6;
const DEFAULT_END_CHARS = 4;

export function shortenUsername(params: Params) {
  const { username, startChars = DEFAULT_START_CHARS, endChars = DEFAULT_END_CHARS } = params;
  const maxLength = startChars + endChars;
  if (username.length <= maxLength) {
    return username;
  }
  return `${username.slice(0, startChars)}...${username.slice(-endChars)}`;
}
